import React, { useState, useMemo, useEffect, useRef } from "react";
import axios from "axios";
import "./Reportes.css";
import {
  FiDownload,
  FiBarChart2,
  FiUsers,
  FiUserCheck,
  FiUserX,
  FiCreditCard,
  FiGift,
  FiDollarSign,
  FiGlobe,
  FiLock,
  FiBarChart,
  FiTrash2,
  FiArrowLeft,
  FiRefreshCw,
  FiUploadCloud,
  FiX,
  FiChevronDown,
  FiChevronUp,
  FiShoppingBag,
  FiLayout,
  FiShare2,
  FiTrendingUp
} from "react-icons/fi";
import { toast } from "react-toastify";
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  LabelList,
} from "recharts";
import { createPortal } from "react-dom";
import PageTitle from "../components/PageTitle";
 
const API = process.env.REACT_APP_API_URL;

const COLORES_INFORME = [
  "#2a292c",
  "#323136",
  "#48474d",
  "#5e5d64",
  "#74737b",
  "#8a8991",
  "#9ca3af"
];

const formatearFechaCredito = (valor) => {
  if (!valor) return "";

  const str = String(valor).trim();

  if (/^\d{8}$/.test(str)) {
    return `${str.slice(0, 4)}-${str.slice(4, 6)}-${str.slice(6, 8)}`;
  }

  const f = new Date(valor);

  if (!isNaN(f)) {
    return f.toISOString().split('T')[0];
  }

  return valor;
};

const formatearFechaHora = (fecha) => {
  if (!fecha) return "Sin datos";

  const f = new Date(fecha);

  const fechaStr = f.toISOString().split("T")[0];

  const hora = f.toLocaleTimeString("es-CO", {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false
  });

  return `${fechaStr} | ${hora}`;
};

function Reportes({ reporteExterno, modoPublico, modoResumen = false }) {

  const [cliente, setCliente] = useState("");
  const [modoGrupo, setModoGrupo] = useState(false);
  const [modalGrupo, setModalGrupo] = useState(false);
  const [nombreGrupo, setNombreGrupo] = useState("");
  const [empresasGrupo, setEmpresasGrupo] = useState([]);
  const [buscarGrupo, setBuscarGrupo] = useState("");
  const [modalNombreGrupo, setModalNombreGrupo] = useState(false);
  const [fechaInicio, setFechaInicio] = useState("");
  const [fechaFin, setFechaFin] = useState("");
  const [loading, setLoading] = useState(false);
  const [reporte, setReporte] = useState(reporteExterno || null);
  const [empresas, setEmpresas] = useState([]);
  const [sugerencias, setSugerencias] = useState([]);
  const [openAcordeon, setOpenAcordeon] = useState(null);
  const [reportesGuardados, setReportesGuardados] = useState([]);
  const [paginaGuardados, setPaginaGuardados] = useState(1);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [reporteAEliminar, setReporteAEliminar] = useState(null);
  const [modalGenerar, setModalGenerar] = useState(false);
  const [tipoSeleccion, setTipoSeleccion] = useState("empresa");
  const [guardando, setGuardando] = useState(false);
  const [subiendoCreditos, setSubiendoCreditos] = useState(false);
  const [informeGuardado, setInformeGuardado] = useState(false);
  const [modalCompartir, setModalCompartir] = useState(false);
  const [reporteCompartir, setReporteCompartir] = useState(null);
  const [tipoCompartir, setTipoCompartir] = useState("completo");

  const totalPaginasGuardados = Math.ceil(
    (reportesGuardados.length || 0) / 10
  );

  const [estadoArchivos, setEstadoArchivos] = useState({
    alDia: false,
    empleados: null,
    asociados: null,
    creditos: null
  });

  const [paginaAfil, setPaginaAfil] = useState(1);
  const [paginaCred, setPaginaCred] = useState(1);
  const [paginaBen, setPaginaBen] = useState(1);

  const totalPaginasAfil = Math.ceil(
    (reporte?.detalle?.afiliacion?.length || 0) / 25
  );

  const totalPaginasCred = Math.ceil(
    (reporte?.detalle?.creditosFull?.length || 0) / 25
  );

  const totalPaginasBen = Math.ceil(
    (reporte?.detalle?.beneficios?.length || 0) / 25
  );

  const afiliacionOrdenada = useMemo(() => {
    return [...(reporte?.detalle?.afiliacion || [])]
      .sort((a, b) => {

        const estadoA =
          a.afiliado ? 0 : 1;

        const estadoB =
          b.afiliado ? 0 : 1;

        if (estadoA !== estadoB) {
          return estadoA - estadoB;
        }

        return String(
          a.documento || ""
        ).localeCompare(
          String(b.documento || ""),
          "es",
          {
            numeric: true
          }
        );

      });
  }, [reporte?.detalle?.afiliacion]);

  const beneficiosOrdenados = useMemo(() => {
    return [...(reporte?.detalle?.beneficios || [])]
      .sort((a, b) => {

        const comparacionPrograma =
          String(a["Programa"] || "")
            .localeCompare(
              String(b["Programa"] || ""),
              "es",
              {
                numeric: true,
                sensitivity: "base"
              }
            );

        if (comparacionPrograma !== 0) {
          return comparacionPrograma;
        }

        return String(
          a["Cédula"] || ""
        ).localeCompare(
          String(b["Cédula"] || ""),
          "es",
          {
            numeric: true
          }
        );

      });
  }, [reporte?.detalle?.beneficios]);

  const creditosOrdenados = useMemo(() => {
    return [...(reporte?.detalle?.creditosFull || [])]
      .sort((a, b) => {

        const comparacionLinea =
          String(a.LINEA || "")
            .localeCompare(
              String(b.LINEA || ""),
              "es",
              {
                numeric: true,
                sensitivity: "base"
              }
            );

        if (comparacionLinea !== 0) {
          return comparacionLinea;
        }

        return String(
          a.CEDULA || ""
        ).localeCompare(
          String(b.CEDULA || ""),
          "es",
          {
            numeric: true
          }
        );

      });
  }, [reporte?.detalle?.creditosFull]);

  const [archivoCreditos, setArchivoCreditos] = useState(null);

  const esPublico = modoPublico === true;
  const esResumenPublico = esPublico && modoResumen === true;

  const refCreditos = useRef();

  useEffect(() => {
    cargarEmpresas();
    consultarEstadoArchivos();
    cargarReportesGuardados();

  }, []);

  const consultarEstadoArchivos = async () => {
    try {

      const res = await axios.get(
        `${API}/api/report/datasources/status`
      );

      setEstadoArchivos(res.data);

    } catch (err) {

      console.error(
        "status archivos",
        err
      );

    }
  };

  const cargarEmpresas = async () => {

    const res = await axios.get(`${API}/api/report/empresas`);
    setEmpresas(res.data);

  }

  const subirArchivoCreditos = async () => {
    if (!archivoCreditos) {
      toast.warn("Selecciona el archivo de créditos");
      return false;
    }

    try {
      setSubiendoCreditos(true);

      const formData = new FormData();

      formData.append(
        "creditos",
        archivoCreditos
      );

      const res = await axios.post(
        `${API}/api/report/datasources/upload`,
        formData
      );

      toast.success(
        res.data?.mensaje ||
        "Archivo de créditos cargado correctamente"
      );

      setArchivoCreditos(null);

      if (refCreditos.current) {
        refCreditos.current.value = "";
      }

      await consultarEstadoArchivos();

      return true;
    } catch (error) {
      console.error(
        "Error cargando créditos:",
        error.response?.data || error.message
      );

      toast.error(
        error.response?.data?.error ||
        "No fue posible cargar el archivo de créditos"
      );

      return false;
    } finally {
      setSubiendoCreditos(false);
    }
  };

  const restablecerConfiguracion = () => {
    setCliente("");
    setModoGrupo(false);
    setNombreGrupo("");
    setEmpresasGrupo([]);
    setBuscarGrupo("");
    setSugerencias([]);
    setFechaInicio("");
    setFechaFin("");
    setArchivoCreditos(null);
    setTipoSeleccion("empresa");

    if (refCreditos.current) {
      refCreditos.current.value = "";
    }
  };

  const generarReporte = async () => {
    if (
      tipoSeleccion === "empresa" &&
      !cliente.trim()
    ) {
      toast.warn("Selecciona una empresa");
      return;
    }

    if (
      tipoSeleccion === "empresa" &&
      !empresas.includes(cliente)
    ) {
      toast.warn(
        "Selecciona una empresa válida de la lista"
      );
      return;
    }

    if (
      tipoSeleccion === "grupo" &&
      empresasGrupo.length === 0
    ) {
      toast.warn(
        "Selecciona al menos una empresa para el grupo"
      );
      return;
    }

    if (
      tipoSeleccion === "grupo" &&
      !nombreGrupo.trim()
    ) {
      toast.warn(
        "Asigna un nombre al grupo de empresas"
      );
      return;
    }

    if (
      tipoSeleccion === "todas" &&
      empresas.length === 0
    ) {
      toast.warn(
        "No hay empresas disponibles para generar el informe"
      );
      return;
    }

    if (!fechaInicio && !fechaFin) {
      toast.warn(
        "Selecciona la fecha inicial y la fecha final"
      );
      return;
    }

    if (!fechaInicio) {
      toast.warn("Selecciona la fecha inicial");
      return;
    }

    if (!fechaFin) {
      toast.warn("Selecciona la fecha final");
      return;
    }

    if (
      new Date(`${fechaInicio}T00:00:00`) >
      new Date(`${fechaFin}T00:00:00`)
    ) {
      toast.warn(
        "La fecha inicial no puede ser posterior a la fecha final"
      );
      return;
    }

    if (
      !estadoArchivos.creditos?.disponible &&
      !archivoCreditos
    ) {
      toast.warn(
        "Debes cargar el archivo de créditos"
      );
      return;
    }

    try {
      setLoading(true);

      /*
       * Si el usuario seleccionó un archivo nuevo,
       * subirlo antes de generar el informe.
       */
      if (archivoCreditos) {
        const cargaCorrecta =
          await subirArchivoCreditos();

        if (!cargaCorrecta) {
          return;
        }
      }

      let payload;

      if (tipoSeleccion === "todas") {
        payload = {
          grupo: "Todas las empresas",
          clientes: [...empresas],
          fechaInicio,
          fechaFin
        };
      } else if (tipoSeleccion === "grupo") {
        payload = {
          grupo:
            nombreGrupo.trim() ||
            "Grupo de empresas",

          clientes: [...empresasGrupo],
          fechaInicio,
          fechaFin
        };
      } else {
        payload = {
          cliente,
          fechaInicio,
          fechaFin
        };
      }

      const res = await axios.post(
        `${API}/api/report/generar`,
        payload
      );

      setModoGrupo(
        tipoSeleccion === "grupo" ||
        tipoSeleccion === "todas"
      );

      if (tipoSeleccion === "todas") {
        setNombreGrupo("Todas las empresas");
        setEmpresasGrupo([...empresas]);
      }

      setInformeGuardado(false);

      setReporte({
        ...res.data.report,

        empresasIncluidas:
          res.data.report?.empresasIncluidas ||
          (
            tipoSeleccion === "todas"
              ? [...empresas]
              : tipoSeleccion === "grupo"
                ? [...empresasGrupo]
                : cliente
                  ? [cliente]
                  : []
          ),

        detalle: res.data.detalle
      });

      setPaginaAfil(1);
      setPaginaCred(1);
      setPaginaBen(1);
      setOpenAcordeon(null);

      /*
       * El modal solo se cierra cuando el informe
       * fue generado correctamente.
       */
      setModalGenerar(false);

      toast.success("Informe generado correctamente");
    } catch (error) {
      console.error(
        "Error generando informe:",
        error.response?.data || error.message
      );

      toast.error(
        error.response?.data?.error ||
        "No fue posible generar el informe"
      );
    } finally {
      setLoading(false);
    }
  };

  // ================= EXPORT =================
  const descargarExcel = () => {

    const params = new URLSearchParams();

    if (modoGrupo) {

      params.append(
        "grupo",
        nombreGrupo
      );

      params.append(
        "clientes",
        JSON.stringify(empresasGrupo)
      );

    } else {

      params.append(
        "cliente",
        cliente
      );

    }

    params.append(
      "fechaInicio",
      fechaInicio
    );

    params.append(
      "fechaFin",
      fechaFin
    );

    window.open(
      `${API}/api/report/descargar?${params}`,
      "_blank"
    );

  };

  // ================= DATA =================

  const dataAfiliacion = useMemo(() => {
    if (!reporte) return [];
    return [
      { name: "Asociados", value: reporte.resumen.afiliados },
      { name: "No Asociados", value: reporte.resumen.noAfiliados }
    ];
  }, [reporte]);

  // 🔥 CRÉDITOS POR LÍNEA (REAL)
  const dataCreditos = useMemo(() => {
    const agregado =
      reporte?.resumen?.creditosPorLinea;

    if (
      agregado &&
      typeof agregado === "object"
    ) {
      return Object.entries(agregado)
        .map(([name, value]) => ({
          name,
          value: Number(value || 0)
        }))
        .filter(
          (item) => item.value > 0
        )
        .sort(
          (a, b) => b.value - a.value
        );
    }

    const creditos =
      reporte?.detalle?.creditosFull || [];

    const conteo = {};

    creditos.forEach((credito) => {
      const linea = String(
        credito.LINEA || "Sin línea"
      ).trim();

      conteo[linea] =
        (conteo[linea] || 0) + 1;
    });

    return Object.entries(conteo)
      .map(([name, value]) => ({
        name,
        value
      }))
      .filter(
        (item) => item.value > 0
      )
      .sort(
        (a, b) => b.value - a.value
      );
  }, [reporte]);

  // 🔥 BENEFICIOS POR PROGRAMA (REAL)
  const dataBeneficios = useMemo(() => {
    const agregado =
      reporte?.resumen
        ?.beneficiosPorPrograma;

    if (
      agregado &&
      typeof agregado === "object"
    ) {
      return Object.entries(agregado)
        .map(([programa, value]) => ({
          name: String(programa).replace(
            /^\d+\s*-\s*/,
            ""
          ),

          value: Number(value || 0)
        }))
        .filter(
          (item) => item.value > 0
        )
        .sort(
          (a, b) => b.value - a.value
        );
    }

    const beneficios =
      reporte?.detalle?.beneficios || [];

    const conteo = {};

    beneficios.forEach((beneficio) => {
      const programa = String(
        beneficio["Programa"] || "Otro"
      ).trim();

      conteo[programa] =
        (conteo[programa] || 0) + 1;
    });

    return Object.entries(conteo)
      .map(([programa, value]) => ({
        name: programa.replace(
          /^\d+\s*-\s*/,
          ""
        ),

        value
      }))
      .filter(
        (item) => item.value > 0
      )
      .sort(
        (a, b) => b.value - a.value
      );
  }, [reporte]);

  const topBeneficios = useMemo(() => {
    return dataBeneficios.slice(0, 5);
  }, [dataBeneficios]);

  // ================= COBERTURA VS USO =================

  const dataCobertura = useMemo(() => {

    if (!reporte) return [];

    const afiliacion =
      Number(reporte.resumen.coberturaAfiliados);

    const creditos =
      Number(reporte.resumen.penetracionCreditos);

    const beneficios =
      Number(reporte.resumen.penetracionBeneficios);

    return [

      {
        name: `Afiliación`,
        valor: afiliacion
      },

      {
        name: `Créditos`,
        valor: creditos
      },

      {
        name: `Beneficios`,
        valor: beneficios
      }

    ];

  }, [reporte]);

  // ================= RANGOS CRÉDITO =================

  const dataRangos = useMemo(() => {

    if (!reporte?.resumen?.rangosCreditos)
      return [];

    return Object.keys(
      reporte.resumen.rangosCreditos
    ).map(k => ({

      name: k,
      value:
        reporte.resumen.rangosCreditos[k]

    }));

  }, [reporte]);

  // ================= BENEFICIOS POR ÁREA =================

  const dataAreas = useMemo(() => {
    const agregado =
      reporte?.resumen?.beneficiosPorArea;

    if (
      !agregado ||
      typeof agregado !== "object"
    ) {
      return [];
    }

    return Object.entries(agregado)
      .map(([name, value]) => ({
        name,
        value: Number(value || 0)
      }))
      .filter(
        (item) => item.value > 0
      )
      .sort(
        (a, b) => b.value - a.value
      );
  }, [reporte]);

  // ================= CRÉDITOS =================

  const guardarGrupo = () => {

    if (!nombreGrupo.trim()) {
      toast.warn("Ingresa nombre");
      return;
    }

    if (empresasGrupo.length === 0) {
      toast.warn("Selecciona empresas");
      return;
    }

    const grupo = {

      nombre: nombreGrupo,

      empresas: [...empresasGrupo]

    };

    const gruposExistentes =

      JSON.parse(
        localStorage.getItem("gruposEmpresas")
      ) || [];

    gruposExistentes.push(grupo);

    localStorage.setItem(
      "gruposEmpresas",
      JSON.stringify(gruposExistentes)
    );

    // 🔥 ESTO FALTABA
    setCliente(nombreGrupo);

    // grupo queda activo
    setModoGrupo(true);

    // cerrar ambos modales
    setModalNombreGrupo(false);

    setModalGrupo(false);

    toast.success("Grupo guardado");

  };

  const cargarReportesGuardados = async () => {

    try {

      const res = await axios.get(
        `${API}/api/report/guardados`
      );

      setReportesGuardados(
        res.data
      );

    } catch (err) {
      console.error(err);
    }

  };

  const guardarInforme = async () => {
    if (!reporte) {
      toast.warn("Genera un informe primero");
      return;
    }

    if (guardando) {
      return;
    }

    try {
      setGuardando(true);

      let payload;

      if (tipoSeleccion === "todas") {
        payload = {
          grupo: "Todas las empresas",
          clientes: [...empresas],
          fechaInicio,
          fechaFin
        };
      } else if (tipoSeleccion === "grupo") {
        payload = {
          grupo:
            nombreGrupo.trim() ||
            "Grupo de empresas",

          clientes: [...empresasGrupo],
          fechaInicio,
          fechaFin
        };
      } else {
        payload = {
          cliente,
          fechaInicio,
          fechaFin
        };
      }

      const res = await axios.post(
        `${API}/api/report/guardar`,
        payload
      );

      setInformeGuardado(true);

      toast.success(
        `Informe guardado y publicado. Código: ${res.data.codigoAcceso}`
      );

      await cargarReportesGuardados();
    } catch (error) {
      console.error(
        "Error guardando informe:",
        error.response?.data || error.message
      );

      toast.error(
        error.response?.data?.error ||
        "No se pudo guardar el informe"
      );
    } finally {
      setGuardando(false);
    }
  };

  const volverAInformes = async () => {
    setReporte(null);
    setInformeGuardado(false);
    setOpenAcordeon(null);
    setPaginaAfil(1);
    setPaginaCred(1);
    setPaginaBen(1);

    await cargarReportesGuardados();
  };

  const compartirCorreo = (r) => {
    const fechaInicioInforme =
      r.fechaInicio
        ? new Date(r.fechaInicio)
          .toISOString()
          .split("T")[0]
        : "No disponible";

    const fechaFinInforme =
      r.fechaFin
        ? new Date(r.fechaFin)
          .toISOString()
          .split("T")[0]
        : "No disponible";

    const asunto =
      `Informe de Gestión ${r.cliente} | ${fechaInicioInforme} → ${fechaFinInforme}`;

    const enlaceInforme =
      `${window.location.origin}/informe/${r.codigoAcceso}`;

    const body =
      `Cordial saludo ${r.cliente},

      Compartimos su Informe de Gestión correspondiente al periodo ${fechaInicioInforme} → ${fechaFinInforme}, elaborado con base en el análisis de afiliación, beneficios y créditos de sus colaboradores en el Fondo de Empleados de ManpowerGroup.

      Puede consultarlo mediante el siguiente enlace:

      ${enlaceInforme}

      Si requiere acompañamiento para revisar los resultados, estaremos atentos para apoyarle.`;

    window.location.href =
      `mailto:?subject=${encodeURIComponent(
        asunto
      )}&body=${encodeURIComponent(body)}`;
  };

  const compartirCorreoResumen = (r) => {

    if (!r.codigoResumen) {
      toast.error(
        "Este informe no tiene código de resumen"
      );
      return;
    }

    const fechaInicioInforme =
      r.fechaInicio
        ? new Date(r.fechaInicio)
          .toISOString()
          .split("T")[0]
        : "No disponible";

    const fechaFinInforme =
      r.fechaFin
        ? new Date(r.fechaFin)
          .toISOString()
          .split("T")[0]
        : "No disponible";

    const enlace =
      `${window.location.origin}/resumen-informe/${r.codigoResumen}`;

    const asunto =
      `Resumen Ejecutivo Informe de Gestión ${r.cliente} | ${fechaInicioInforme} → ${fechaFinInforme}`;

    const body =
      `Cordial saludo ${r.cliente},

      Compartimos su Informe de Gestión correspondiente al periodo ${fechaInicioInforme} → ${fechaFinInforme}, elaborado con base en el análisis de afiliación, beneficios y créditos de sus colaboradores en el Fondo de Empleados de ManpowerGroup.

      Puede consultarlo mediante el siguiente enlace:
      
      ${enlace}

      Si requiere acompañamiento para revisar los resultados, estaremos atentos para apoyarle.`;

    window.location.href =
      `mailto:?subject=${encodeURIComponent(
        asunto
      )}&body=${encodeURIComponent(body)}`;
  };

  const toggleEstado = async (r) => {

    await axios.patch(
      `${API}/api/report/estado/${r._id}`
    );

    cargarReportesGuardados();

  };

  const eliminarInforme = async (id) => {

    try {

      await axios.delete(
        `${API}/api/report/eliminar/${id}`
      );

      toast.success("Informe eliminado");

      cargarReportesGuardados();

    } catch (err) {

      console.error(err);

      toast.error("No se pudo eliminar");

    }

  };


  const verInformeGuardado = (r) => {

    if (!r.codigoAcceso) {
      toast.error("Informe sin código");
      return;
    }

    window.open(
      `${window.location.origin}/informe/${r.codigoAcceso}`,
      "_blank"
    );

  };

  const verResumenGuardado = (r) => {

    if (!r.codigoResumen) {
      toast.error(
        "Este informe no tiene código de resumen"
      );
      return;
    }

    window.open(
      `${window.location.origin}/resumen-informe/${r.codigoResumen}`,
      "_blank"
    );
  };

  const empresasFiltradas = [...empresas]
    .sort((a, b) => a.localeCompare(b, "es", { sensitivity: "base" }))
    .filter((emp) =>
      emp.toLowerCase().includes(buscarGrupo.toLowerCase())
    );

  const todasSeleccionadas =
    empresasFiltradas.length > 0 &&
    empresasFiltradas.every((emp) => empresasGrupo.includes(emp));


  const fuenteActualizadaParaInforme = (
    ultimaCarga,
    fechaCorte
  ) => {
    if (!ultimaCarga || !fechaCorte) {
      return false;
    }

    const fechaFuente = new Date(ultimaCarga);

    const fechaInforme = new Date(
      `${fechaCorte}T00:00:00`
    );

    fechaFuente.setHours(0, 0, 0, 0);
    fechaInforme.setHours(0, 0, 0, 0);

    if (
      Number.isNaN(fechaFuente.getTime()) ||
      Number.isNaN(fechaInforme.getTime())
    ) {
      return false;
    }

    return fechaFuente >= fechaInforme;
  };

  const empleadosActualizados =
    fuenteActualizadaParaInforme(
      estadoArchivos.empleados?.ultimaCarga,
      fechaFin
    );

  const asociadosActualizados =
    fuenteActualizadaParaInforme(
      estadoArchivos.asociados?.ultimaCarga,
      fechaFin
    );

  const creditosActualizados =
    fuenteActualizadaParaInforme(
      estadoArchivos.creditos?.ultimaCarga,
      fechaFin
    );

  const tieneDatosAfiliacion =
    dataAfiliacion.some(
      (item) => Number(item.value) > 0
    );

  const tieneDatosBeneficios =
    topBeneficios.some(
      (item) => Number(item.value) > 0
    );

  const tieneDatosAreas =
    dataAreas.some(
      (item) => Number(item.value) > 0
    );

  const tieneDatosCreditos =
    dataCreditos.some(
      (item) => Number(item.value) > 0
    );

  const tieneDatosRangos =
    dataRangos.some(
      (item) => Number(item.value) > 0
    );

  const tieneDatosCobertura =
    dataCobertura.some(
      (item) => Number(item.valor) > 0
    );

  const tieneDetalleAfiliacion =
    (reporte?.detalle?.afiliacion?.length || 0) > 0;

  const tieneDetalleCreditos =
    (reporte?.detalle?.creditosFull?.length || 0) > 0;

  const tieneDetalleBeneficios =
    (reporte?.detalle?.beneficios?.length || 0) > 0;

  const tieneAlgunaGrafica =
    tieneDatosAfiliacion ||
    tieneDatosBeneficios ||
    tieneDatosAreas ||
    tieneDatosCreditos ||
    tieneDatosRangos ||
    tieneDatosCobertura;

  const tieneAlgunaTabla =
    tieneDetalleAfiliacion ||
    tieneDetalleCreditos ||
    tieneDetalleBeneficios;

  const resumenEjecutivo = useMemo(() => {
    if (!reporte?.resumen) {
      return [];
    }

    const resumen = reporte.resumen;
    const conclusiones = [];

    const empresasIncluidas =
      Array.isArray(reporte.empresasIncluidas)
        ? reporte.empresasIncluidas.filter(Boolean)
        : [];

    const totalEmpleados =
      Number(resumen.totalEmpleados || 0);

    const afiliados =
      Number(resumen.afiliados || 0);

    const coberturaAfiliados =
      Number(resumen.coberturaAfiliados || 0);

    const totalCreditos =
      Number(resumen.totalCreditos || 0);

    const totalPersonasConCredito =
      Number(resumen.totalPersonasConCredito || 0);

    const valorCreditos =
      Number(resumen.valorCreditos || 0);

    const totalBeneficios =
      Number(resumen.totalBeneficios || 0);

    const valorBeneficios =
      Number(resumen.valorBeneficios || 0);

    if (empresasIncluidas.length > 0) {
      const limiteVisible = 10;

      const empresasVisibles =
        empresasIncluidas.slice(
          0,
          limiteVisible
        );

      const empresasRestantes =
        empresasIncluidas.length -
        empresasVisibles.length;

      const textoEmpresas =
        empresasVisibles.join(", ");

      conclusiones.push(
        empresasIncluidas.length === 1
          ? `Este informe corresponde a la empresa ${empresasIncluidas[0]}.`
          : `Este informe incluye ${empresasIncluidas.length.toLocaleString(
            "es-CO"
          )} empresas: ${textoEmpresas}${empresasRestantes > 0
            ? ` y ${empresasRestantes.toLocaleString(
              "es-CO"
            )} empresas adicionales`
            : ""
          }.`
      );
    }

    conclusiones.push(
      `La población analizada corresponde a ${totalEmpleados.toLocaleString(
        "es-CO"
      )} empleados.`
    );

    conclusiones.push(
      `${afiliados.toLocaleString(
        "es-CO"
      )} empleados están asociados, lo que representa una cobertura del ${coberturaAfiliados.toLocaleString(
        "es-CO"
      )}%.`
    );

    if (totalCreditos > 0) {
      conclusiones.push(
        `Durante el periodo se registraron ${totalCreditos.toLocaleString(
          "es-CO"
        )} operaciones de crédito por un valor total de $${valorCreditos.toLocaleString(
          "es-CO"
        )}.`
      );
    }

    if (totalPersonasConCredito > 0) {
      conclusiones.push(
        `${totalPersonasConCredito.toLocaleString(
          "es-CO"
        )} empleados accedieron al menos a una operación de crédito.`
      );
    }

    if (totalBeneficios > 0) {
      conclusiones.push(
        `Se registraron ${totalBeneficios.toLocaleString(
          "es-CO"
        )} beneficios por una transferencia solidaria acumulada de $${valorBeneficios.toLocaleString(
          "es-CO"
        )}.`
      );
    }

    return conclusiones;
  }, [reporte]);

  const getTrianglePath = (
    x,
    y,
    width,
    height
  ) => {
    return `
    M${x},${y + height}

    C${x + width / 3},${y + height}
    ${x + width / 2},${y + height / 3}

    ${x + width / 2},${y}

    C${x + width / 2},${y + height / 3}
    ${x + (2 * width) / 3},${y + height}

    ${x + width},${y + height}

    Z
  `;
  };

  const TriangleBar = (props) => {
    const {
      fill,
      x,
      y,
      width,
      height
    } = props;

    return (
      <path
        d={getTrianglePath(
          Number(x),
          Number(y),
          Number(width),
          Number(height)
        )}
        fill={fill}
      />
    );
  };

  const abrirModalCompartir = (reporte) => {
    setReporteCompartir(reporte);
    setTipoCompartir("completo");
    setModalCompartir(true);
  };

  const compartirInforme = () => {

    if (!reporteCompartir) {
      return;
    }

    if (tipoCompartir === "resumen") {
      compartirCorreoResumen(
        reporteCompartir
      );
    } else {
      compartirCorreo(
        reporteCompartir
      );
    }

    setModalCompartir(false);
  };


  return (

    <>

    <PageTitle title="Informes" />

    <div className="rep-root">

      {/* ================= HEADER ================= */}
      <header className="rep-header">
        {!esPublico && (
          <h2 className="rep-title">
            | Informes de Gestión
          </h2>
        )}

        {!esPublico && (
          <div className="rep-actions">
            {!reporte && (
              <button
                type="button"
                className="rep-btn-primary"
                onClick={() =>
                  setModalGenerar(true)
                }
              >
                <FiBarChart2 />
                Nuevo informe
              </button>
            )}

            {reporte && (
              <>
                <button
                  type="button"
                  className="rep-btn-secondary"
                  onClick={volverAInformes}
                  disabled={guardando}
                >
                  <FiArrowLeft />
                  Volver a informes
                </button>

                <button
                  type="button"
                  className="rep-btn-secondary"
                  onClick={descargarExcel}
                  disabled={guardando}
                >
                  <FiDownload />
                  Exportar Excel
                </button>

                {!informeGuardado && (
                  <button
                    type="button"
                    className="rep-btn-primary"
                    onClick={guardarInforme}
                    disabled={guardando}
                  >
                    <FiBarChart2 />

                    {guardando
                      ? "Guardando..."
                      : "Guardar y publicar"}
                  </button>
                )}
              </>
            )}
          </div>
        )}
      </header>

      {modalGrupo &&
        createPortal(
          <div
            className="rep-generator-overlay"
            onClick={() => {
              setModalGrupo(false);
              setBuscarGrupo("");
            }}
          >
            <div
              className="rep-group-modal-modern"
              role="dialog"
              aria-modal="true"
              aria-labelledby="group-modal-title"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="rep-generator-header">
                <div>
                  <h3 id="group-modal-title">
                    Configurar Grupo de Empresas
                  </h3>

                  <p>
                    Busca y selecciona las empresas que
                    formarán parte del informe.
                  </p>
                </div>

                <button
                  type="button"
                  className="rep-generator-close"
                  onClick={() => {
                    setModalGrupo(false);
                    setBuscarGrupo("");
                  }}
                  aria-label="Cerrar"
                >
                  <FiX />
                </button>
              </div>

              <div className="rep-group-modal-body">
                <div className="rep-group-toolbar">
                  <div className="rep-generator-field">
                    <label htmlFor="buscarEmpresaGrupo">
                      Buscar empresa
                    </label>

                    <input
                      id="buscarEmpresaGrupo"
                      type="search"
                      placeholder="Escribe el nombre de una empresa..."
                      value={buscarGrupo}
                      onChange={(e) =>
                        setBuscarGrupo(e.target.value)
                      }
                    />
                  </div>

                  <label className="rep-select-all">
                    <input
                      type="checkbox"
                      checked={todasSeleccionadas}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setEmpresasGrupo([
                            ...new Set([
                              ...empresasGrupo,
                              ...empresasFiltradas
                            ])
                          ]);
                        } else {
                          setEmpresasGrupo(
                            empresasGrupo.filter(
                              (empresa) =>
                                !empresasFiltradas.includes(
                                  empresa
                                )
                            )
                          );
                        }
                      }}
                    />

                    <span>
                      Seleccionar resultados visibles
                    </span>
                  </label>
                </div>

                <div className="rep-group-selection-summary">
                  <div>
                    <strong>
                      {empresasGrupo.length}
                    </strong>

                    <span>
                      empresa
                      {empresasGrupo.length === 1
                        ? ""
                        : "s"} seleccionada
                      {empresasGrupo.length === 1
                        ? ""
                        : "s"}
                    </span>
                  </div>

                  {empresasGrupo.length > 0 && (
                    <button
                      type="button"
                      className="rep-clear-selection"
                      onClick={() =>
                        setEmpresasGrupo([])
                      }
                    >
                      Limpiar selección
                    </button>
                  )}
                </div>

                <div className="rep-group-company-list">
                  {empresasFiltradas.length > 0 ? (
                    empresasFiltradas.map((empresa) => {
                      const seleccionada =
                        empresasGrupo.includes(empresa);

                      return (
                        <label
                          key={empresa}
                          className={`rep-group-company-item ${seleccionada
                            ? "selected"
                            : ""
                            }`}
                        >
                          <input
                            type="checkbox"
                            checked={seleccionada}
                            onChange={() => {
                              if (seleccionada) {
                                setEmpresasGrupo(
                                  empresasGrupo.filter(
                                    (item) =>
                                      item !== empresa
                                  )
                                );
                              } else {
                                setEmpresasGrupo([
                                  ...empresasGrupo,
                                  empresa
                                ]);
                              }
                            }}
                          />

                          <span>{empresa}</span>
                        </label>
                      );
                    })
                  ) : (
                    <div className="rep-group-empty">
                      <FiUsers />

                      <strong>
                        No se encontraron empresas
                      </strong>

                      <span>
                        Prueba con otro término de búsqueda.
                      </span>
                    </div>
                  )}
                </div>
              </div>

              <div className="rep-generator-footer">
                <button
                  type="button"
                  className="rep-btn-ghost"
                  onClick={() => {
                    setEmpresasGrupo([]);
                    setBuscarGrupo("");
                  }}
                  disabled={
                    empresasGrupo.length === 0 &&
                    !buscarGrupo
                  }
                >
                  <FiRefreshCw />
                  Restablecer
                </button>

                <div>
                  <button
                    type="button"
                    className="rep-btn-primary"
                    onClick={() => {
                      if (
                        empresasGrupo.length === 0
                      ) {
                        toast.warn(
                          "Selecciona al menos una empresa"
                        );
                        return;
                      }

                      setModalNombreGrupo(true);
                    }}
                  >
                    Continuar
                  </button>
                </div>
              </div>
            </div>
          </div>,
          document.body
        )}

      {modalNombreGrupo && (
        createPortal(
          <div className="rep-generator-overlay">

            <div className="grupo-modal mini-modal">

              <h3>Nombre del Grupo</h3>

              <input
                className="grupo-input"
                placeholder="Ej: Grupo Antioquia"
                value={nombreGrupo}
                onChange={(e) =>
                  setNombreGrupo(
                    e.target.value
                  )
                }
              />

              <div className="grupo-modal-footer">

                <button
                  className="rep-btn-secondary"
                  onClick={() =>
                    setModalNombreGrupo(false)
                  }
                >

                  Cancelar

                </button>

                <button
                  className="rep-btn-primary"
                  onClick={() => {

                    if (!nombreGrupo.trim()) {

                      toast.warn(
                        "Ingresa nombre del grupo"
                      );

                      return;

                    }

                    guardarGrupo();

                    setModalNombreGrupo(false);

                  }}
                >

                  Guardar

                </button>

              </div>

            </div>

          </div>,
          document.body
        )

      )}

      {reporte && esPublico && (

        <div className="rep-public-header">

          <div className="rep-public-top">

            {/* IZQUIERDA → LOGO */}
            <img
              src="/static/media/Logo.fdb613f0c66d63204fc4.png"
              alt="Logo"
              className="rep-logo"
            />

            {/* CENTRO → TITULO */}
            <div className="rep-title-box">
              <h1>Informe de Gestión</h1>
              <span className="rep-subtitle">
                Fondo de Empleados de ManpowerGroup
              </span>
            </div>

            {/* DERECHA → BOTÓN */}
            {!esResumenPublico && (
              <button
                className="rep-btn-primary"
                onClick={() => {
                  window.open(
                    `${API}/api/report/descargar-excel-guardado/${reporte._id}`,
                    "_blank"
                  );
                }}
              >
                <FiDownload />
                Exportar Excel
              </button>
            )}

          </div>

          <div className="rep-public-info">

            <p>
              <strong>Cliente:</strong> {reporte.cliente}
            </p>

            <p>
              <strong>Periodo:</strong>{" "}
              {reporte?.fechaInicio && reporte?.fechaFin
                ? `${new Date(reporte.fechaInicio).toISOString().split("T")[0]} → ${new Date(reporte.fechaFin).toISOString().split("T")[0]}`
                : "No disponible"}
            </p>

            <p>
              <strong>Vigencia:</strong>{" "}
              {(() => {
                const hoy = new Date();
                const vencimiento = new Date();
                vencimiento.setDate(hoy.getDate() + 30);

                return `${hoy.toISOString().split("T")[0]} → ${vencimiento.toISOString().split("T")[0]}`;
              })()}
            </p>

          </div>

        </div>

      )}

      {reporte && resumenEjecutivo.length > 0 && (
        <section className="rep-executive-summary">
          <div className="rep-section-heading">
            <span className="rep-section-label">
              Resumen ejecutivo
            </span>

            <h2>
              Principales resultados del informe
            </h2>

            <p>
              Síntesis de los principales indicadores de afiliación,
              beneficios y créditos.
            </p>
          </div>

          <ul>
            {resumenEjecutivo.map(
              (conclusion, index) => (
                <li key={`conclusion-${index}`}>
                  {conclusion}
                </li>
              )
            )}
          </ul>
        </section>
      )}

      {/* ================= KPIs ================= */}
      {reporte && (
        <div className="rep-summary">

          <div className="rep-card">
            <div className="kpi-icon">
              <FiUsers />
            </div>

            <p>Total Empleados</p>

            <h2>{reporte.resumen.totalEmpleados.toLocaleString("es-CO")}</h2>
          </div>

          <div className="rep-card">
            <div className="kpi-icon">
              <FiUserCheck />
            </div>

            <p>Asociados</p>

            <h2>
              {Number(
                reporte.resumen.afiliados
              ).toLocaleString('es-CO')}
              <span className="kpi-percent">
                ({reporte.resumen.coberturaAfiliados}%)
              </span>
            </h2>
          </div>

          <div className="rep-card">
            <div className="kpi-icon">
              <FiUserX />
            </div>

            <p>No Asociados</p>

            <h2>
              {Number(
                reporte.resumen.noAfiliados
              ).toLocaleString('es-CO')}
              <span className="kpi-percent">
                ({reporte.resumen.coberturaNoAfiliados}%)
              </span>
            </h2>
          </div>

          <div className="rep-card">
            <div className="kpi-icon">
              <FiGift />
            </div>

            <p>Cantidad de Beneficios</p>

            <h2>{reporte.resumen.totalBeneficios.toLocaleString("es-CO")}</h2>
          </div>


          <div className="rep-card">
            <div className="kpi-icon">
              <FiDollarSign />
            </div>

            <p>Valor Beneficios</p>

            <h2>
              $
              {Number(
                reporte.resumen.valorBeneficios || 0
              ).toLocaleString("es-CO")}
            </h2>
          </div>

          <div className="rep-card">
            <div className="kpi-icon">
              <FiShoppingBag />
            </div>

            <p>Cantidad de Créditos</p>

            <h2>
              {Number(
                reporte?.resumen?.totalCreditos || 0
              ).toLocaleString("es-CO")}
            </h2>
          </div>

          <div className="rep-card">
            <div className="kpi-icon">
              <FiDollarSign />
            </div>

            <p>Valor Créditos</p>

            <h2>
              $
              {Number(
                reporte.resumen.valorCreditos || 0
              ).toLocaleString("es-CO")}
            </h2>
          </div>

          {Number(
            reporte.resumen.totalPersonasConCredito || 0
          ) > 0 && (
              <div className="rep-card">
                <div className="kpi-icon">
                  <FiCreditCard />
                </div>

                <p>Empleados con Crédito</p>

                <h2>
                  {Number(
                    reporte.resumen.totalPersonasConCredito || 0
                  ).toLocaleString("es-CO")}

                  <span className="kpi-percent">
                    ({Number(
                      reporte.resumen.penetracionCreditos || 0
                    ).toLocaleString("es-CO")}%)
                  </span>
                </h2>

              </div>
            )}

          {Number(
            reporte.resumen.ticketPromedioCredito || 0
          ) > 0 && (
              <div className="rep-card">
                <div className="kpi-icon">
                  <FiBarChart2 />
                </div>

                <p>Promedio por Crédito</p>

                <h2>
                  $
                  {Number(
                    reporte.resumen.ticketPromedioCredito || 0
                  ).toLocaleString("es-CO")}
                </h2>

              </div>
            )}

        </div>
      )}


      {/* ================= GRÁFICAS ================= */}
      {reporte && tieneAlgunaGrafica && (
        <div className="rep-charts">

          {/* 🔵 AFILIACIÓN */}
          {tieneDatosAfiliacion && (
            <div className="rep-chart-box">
              <div className="rep-chart-header">
                <div>
                  <h3>
                    <FiUserCheck />
                    Cobertura de afiliación
                  </h3>

                  <p>
                    Distribución entre empleados asociados y no asociados.
                  </p>
                </div>
              </div>

              <ResponsiveContainer
                width="100%"
                height={280}
              >
                <PieChart
                  margin={{
                    top: 10,
                    right: 55,
                    bottom: 5,
                    left: 55
                  }}
                >
                  <Pie
                    data={dataAfiliacion}
                    dataKey="value"
                    nameKey="name"
                    innerRadius={false}
                    outerRadius={100}
                    paddingAngle={false}
                    labelLine={true}
                    fontSize={15}
                    label={({ name, value }) =>
                      `${name}: ${Number(value).toLocaleString(
                        "es-CO"
                      )}`
                    }
                  >
                    <Cell fill="#2a292c" />
                    <Cell fill="#c7c7c7" />
                  </Pie>

                  <Tooltip
                    formatter={(value) =>
                      Number(value).toLocaleString("es-CO")
                    }
                  />
                </PieChart>
              </ResponsiveContainer>
            </div>
          )}

          {/* 🟠 BENEFICIOS */}
          {tieneDatosBeneficios && (
            <div className="rep-chart-box">
              <div className="rep-chart-header">
                <div>
                  <h3>
                    <FiGift />
                    Principales beneficios por programa
                  </h3>

                  <p>
                    Top 5 programas con mayor número de beneficiados
                    durante el periodo.
                  </p>
                </div>
              </div>

              <div
                style={{
                  maxHeight: "430px",
                  overflowY: "auto"
                }}
              >
                <ResponsiveContainer
                  width="100%"
                  height={Math.max(
                    topBeneficios.length * 46,
                    280
                  )}
                >
                  <BarChart
                    layout="vertical"
                    data={topBeneficios}
                    margin={{
                      top: 10,
                      right: 45,
                      bottom: 5,
                      left: -30
                    }}
                  >
                    <CartesianGrid
                      strokeDasharray="3 3"
                      horizontal={false}
                    />

                    <XAxis
                      type="number"
                      allowDecimals={false}
                    />

                    <YAxis
                      type="category"
                      dataKey="name"
                      width={155}
                      tick={{
                        fontSize: 13
                      }}
                    />

                    <Tooltip
                      formatter={(value) => [
                        Number(value).toLocaleString("es-CO"),
                        "Beneficios"
                      ]}
                    />

                    <Bar
                      dataKey="value"
                      fill="#2a292c"
                      radius={[0, 7, 7, 0]}
                    >
                      <LabelList
                        dataKey="value"
                        position="right"
                        formatter={(value) =>
                          Number(value).toLocaleString("es-CO")
                        }
                      />
                    </Bar>
                  </BarChart>
                </ResponsiveContainer>
              </div>
            </div>
          )}

          {/* 🟢 BENEFICIOS POR ÁREA */}
          {tieneDatosAreas && (
            <div className="rep-chart-box">
              <div className="rep-chart-header">
                <div>
                  <h3>
                    <FiLayout />
                    Distribución de beneficios por área
                  </h3>

                  <p>
                    Participación de cada categoría dentro del total
                    de beneficios entregados.
                  </p>
                </div>
              </div>

              <ResponsiveContainer
                width="100%"
                height={300}
              >
                <PieChart
                  margin={{
                    top: 10,
                    right: 20,
                    bottom: 50,
                    left: 20
                  }}
                >
                  <Pie
                    data={dataAreas}
                    dataKey="value"
                    nameKey="name"
                    innerRadius={55}
                    outerRadius={90}
                    cornerRadius={7}
                    paddingAngle={3}
                    labelLine={true}
                    fontSize={13}
                    label={({ name, percent }) =>
                      `${name}: ${(percent * 100).toFixed(0)}%`
                    }
                  >
                    {dataAreas.map((entry, index) => (
                      <Cell
                        key={`area-${entry.name}`}
                        fill={
                          COLORES_INFORME[
                          index % COLORES_INFORME.length
                          ]
                        }
                      />
                    ))}
                  </Pie>

                  <Tooltip
                    formatter={(value) => [
                      Number(value).toLocaleString("es-CO"),
                      "Beneficios"
                    ]}
                  />
                </PieChart>
              </ResponsiveContainer>
            </div>
          )}

          {/* 🟣 CRÉDITOS TRIANGLE */}
          {tieneDatosCreditos && (
            <div className="rep-chart-box">
              <div className="rep-chart-header">
                <div>
                  <h3>
                    <FiCreditCard />
                    Créditos por línea
                  </h3>

                  <p>
                    Número de operaciones registradas en cada línea
                    de crédito durante el periodo.
                  </p>
                </div>
              </div>

              <ResponsiveContainer
                width="100%"
                height={280}
              >
                <BarChart
                  data={dataCreditos}
                  margin={{
                    top: 20,
                    right: 5,
                    left: 5,
                    bottom: 0
                  }}
                >
                  <CartesianGrid
                    strokeDasharray="3 3"
                    vertical={false}
                  />

                  <XAxis
                    dataKey="name"
                    tick={{
                      fontSize: 13
                    }}
                    interval={0}
                    angle={-20}
                    textAnchor="end"
                    height={65}
                  />

                  <YAxis allowDecimals={false} />

                  <Tooltip
                    formatter={(value) => [
                      Number(value).toLocaleString("es-CO"),
                      "Operaciones"
                    ]}
                  />

                  <Bar
                    dataKey="value"
                    fill="#2a292c"
                    shape={<TriangleBar />}
                  >
                    <LabelList
                      dataKey="value"
                      position="top"
                      formatter={(value) =>
                        Number(value).toLocaleString("es-CO")
                      }
                    />
                  </Bar>
                </BarChart>
              </ResponsiveContainer>
            </div>
          )}

          {/* 🟣 RANGOS DE CRÉDITO */}

          {tieneDatosRangos && (
            <div className="rep-chart-box">
              <div className="rep-chart-header">
                <div>
                  <h3>
                    <FiDollarSign />
                    Créditos por rango de desembolso
                  </h3>

                  <p>
                    Número de operaciones agrupadas según el valor
                    desembolsado.
                  </p>
                </div>
              </div>

              <ResponsiveContainer
                width="100%"
                height={280}
              >
                <BarChart
                  data={dataRangos}
                  margin={{
                    top: 20,
                    right: 20,
                    left: 5,
                    bottom: 5
                  }}
                >
                  <CartesianGrid
                    strokeDasharray="3 3"
                    vertical={false}
                  />

                  <XAxis dataKey="name" />

                  <YAxis allowDecimals={false} />

                  <Tooltip
                    formatter={(value) => [
                      Number(value).toLocaleString("es-CO"),
                      "Operaciones"
                    ]}
                  />

                  <Bar
                    dataKey="value"
                    fill="#2a292c"
                    radius={[7, 7, 0, 0]}
                  >
                    <LabelList
                      dataKey="value"
                      position="top"
                      formatter={(value) =>
                        Number(value).toLocaleString("es-CO")
                      }
                    />
                  </Bar>
                </BarChart>
              </ResponsiveContainer>
            </div>
          )}

          {/* 🟢 COBERTURA VS USO */}
          {tieneDatosCobertura && (
            <div className="rep-chart-box">
              <div className="rep-chart-header">
                <div>
                  <h3>
                    <FiBarChart2 />
                    Cobertura y utilización
                  </h3>

                  <p>
                    Comparación porcentual de afiliación, acceso a beneficios
                    y utilización de créditos.
                  </p>
                </div>
              </div>

              <ResponsiveContainer
                width="100%"
                height={280}
              >
                <BarChart
                  layout="vertical"
                  data={dataCobertura}
                  margin={{
                    top: 10,
                    right: 70,
                    bottom: 5,
                    left: -80
                  }}
                >
                  <CartesianGrid
                    strokeDasharray="3 3"
                    horizontal={false}
                  />

                  <XAxis
                    type="number"
                    domain={[0, 100]}
                    tickFormatter={(value) =>
                      `${value}%`
                    }
                  />

                  <YAxis
                    type="category"
                    dataKey="name"
                    fontSize={14}
                    width={165}
                  />

                  <Tooltip
                    formatter={(value) => [
                      `${value}%`,
                      "Porcentaje"
                    ]}
                  />

                  <Bar
                    dataKey="valor"
                    fill="#2a292c"
                    radius={[0, 7, 7, 0]}
                  >
                    <LabelList
                      dataKey="valor"
                      position="right"
                      formatter={(value) =>
                        `${value}%`
                      }
                    />
                  </Bar>
                </BarChart>
              </ResponsiveContainer>
            </div>
          )}
        </div>
      )}

      {reporte && tieneAlgunaTabla && !esResumenPublico && (
        <div className="acordeones-reportes">

          {tieneDetalleAfiliacion && (
            <>
              <div
                className={`acc-header ${openAcordeon === "afil"
                  ? "is-open"
                  : ""
                  }`}
                onClick={() =>
                  setOpenAcordeon(
                    openAcordeon === "afil"
                      ? null
                      : "afil"
                  )
                }
                role="button"
                tabIndex={0}
                aria-expanded={openAcordeon === "afil"}
              >
                <div className="acc-header-info">
                  <span>Detalle de Afiliación</span>

                  <small>
                    {reporte.detalle.afiliacion.length.toLocaleString(
                      "es-CO"
                    )} Empleados
                  </small>
                </div>

                <div className="acc-toggle-icon">
                  {openAcordeon === "afil"
                    ? <FiChevronUp />
                    : <FiChevronDown />}
                </div>
              </div>

              {openAcordeon === "afil" && (
                <div className="acc-body">

                  <table>

                    <thead>
                      <tr>
                        <th>Identificación</th>
                        <th>Nombre</th>
                        <th>Estado</th>
                      </tr>
                    </thead>

                    <tbody>

                      {afiliacionOrdenada
                        .sort((a, b) => {
                          const estadoA = a.afiliado
                            ? "Asociado"
                            : "No asociado";

                          const estadoB = b.afiliado
                            ? "Asociado"
                            : "No asociado";

                          const comparacionEstado =
                            estadoA.localeCompare(
                              estadoB,
                              "es",
                              {
                                sensitivity: "base"
                              }
                            );

                          if (comparacionEstado !== 0) {
                            return comparacionEstado;
                          }

                          return String(
                            a.documento || ""
                          ).localeCompare(
                            String(b.documento || ""),
                            "es",
                            {
                              numeric: true,
                              sensitivity: "base"
                            }
                          );
                        })
                        .slice(
                          (paginaAfil - 1) * 25,
                          paginaAfil * 25
                        )
                        .map((registro) => (
                          <tr key={registro.documento}>
                            <td>{registro.documento}</td>
                            <td>{registro.nombre}</td>
                            <td>
                              {registro.afiliado
                                ? "Asociado"
                                : "No asociado"}
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>

                  <div className="pager">
                    <button
                      disabled={paginaAfil === 1}
                      onClick={() => setPaginaAfil(paginaAfil - 1)}
                    >
                      Anterior
                    </button>
                    <span>
                      Página {paginaAfil} de {totalPaginasAfil}
                    </span>
                    <button
                      disabled={paginaAfil === totalPaginasAfil}
                      onClick={() => setPaginaAfil(paginaAfil + 1)}
                    >
                      Siguiente
                    </button>
                  </div>

                </div>
              )}
            </>
          )}

          {tieneDetalleBeneficios && (
            <>
              <div
                className={`acc-header ${openAcordeon === "ben"
                  ? "is-open"
                  : ""
                  }`}
                onClick={() =>
                  setOpenAcordeon(
                    openAcordeon === "ben"
                      ? null
                      : "ben"
                  )
                }
                role="button"
                tabIndex={0}
                aria-expanded={openAcordeon === "ben"}
              >
                <div className="acc-header-info">
                  <span>Detalle de Beneficios</span>

                  <small>
                    {reporte.detalle.beneficios.length.toLocaleString(
                      "es-CO"
                    )} Beneficios
                  </small>
                </div>

                <div className="acc-toggle-icon">
                  {openAcordeon === "ben"
                    ? <FiChevronUp />
                    : <FiChevronDown />}
                </div>
              </div>

              {openAcordeon === "ben" && (
                <div className="acc-body">
                  <table>
                    <thead>
                      <tr>
                        <th>Identificación</th>
                        <th>Asociado</th>
                        <th>Programa</th>
                        <th>Transferencia</th>
                        <th>Fecha</th>
                      </tr>
                    </thead>

                    <tbody>
                      {beneficiosOrdenados
                        .sort((a, b) => {
                          const programaA = String(
                            a["Programa"] || ""
                          ).trim();

                          const programaB = String(
                            b["Programa"] || ""
                          ).trim();

                          const comparacionPrograma =
                            programaA.localeCompare(
                              programaB,
                              "es",
                              {
                                numeric: true,
                                sensitivity: "base"
                              }
                            );

                          if (comparacionPrograma !== 0) {
                            return comparacionPrograma;
                          }

                          return String(
                            a["Cédula"] || ""
                          ).localeCompare(
                            String(b["Cédula"] || ""),
                            "es",
                            {
                              numeric: true,
                              sensitivity: "base"
                            }
                          );
                        })
                        .slice(
                          (paginaBen - 1) * 25,
                          paginaBen * 25
                        )
                        .map((beneficio, index) => (
                          <tr
                            key={`${beneficio["Cédula"]}-${beneficio["Fecha"]}-${beneficio["Programa"]}-${index}`}
                          >
                            <td>
                              {beneficio["Cédula"]}
                            </td>

                            <td>
                              {beneficio["Asociado"]}
                            </td>

                            <td>
                              {beneficio["Programa"]?.replace(
                                /^\d+\s*-\s*/,
                                ""
                              )}
                            </td>

                            <td>
                              $
                              {Number(
                                beneficio["Transferencia"] || 0
                              ).toLocaleString("es-CO")}
                            </td>

                            <td>
                              {beneficio["Fecha"]}
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>

                  <div className="pager">
                    <button
                      type="button"
                      disabled={paginaBen === 1}
                      onClick={() =>
                        setPaginaBen(
                          (paginaActual) =>
                            paginaActual - 1
                        )
                      }
                    >
                      Anterior
                    </button>

                    <span>
                      Página {paginaBen} de{" "}
                      {totalPaginasBen}
                    </span>

                    <button
                      type="button"
                      disabled={
                        paginaBen >= totalPaginasBen
                      }
                      onClick={() =>
                        setPaginaBen(
                          (paginaActual) =>
                            paginaActual + 1
                        )
                      }
                    >
                      Siguiente
                    </button>
                  </div>
                </div>
              )}
            </>
          )}

          {tieneDetalleCreditos && (
            <>
              <div
                className={`acc-header ${openAcordeon === "cred"
                  ? "is-open"
                  : ""
                  }`}
                onClick={() =>
                  setOpenAcordeon(
                    openAcordeon === "cred"
                      ? null
                      : "cred"
                  )
                }
                role="button"
                tabIndex={0}
                aria-expanded={openAcordeon === "cred"}
              >
                <div className="acc-header-info">
                  <span>Detalle de Créditos</span>

                  <small>
                    {reporte.detalle.creditosFull.length.toLocaleString(
                      "es-CO"
                    )} Operaciones
                  </small>
                </div>

                <div className="acc-toggle-icon">
                  {openAcordeon === "cred"
                    ? <FiChevronUp />
                    : <FiChevronDown />}
                </div>
              </div>

              {openAcordeon === "cred" && (
                <div className="acc-body">
                  <table>
                    <thead>
                      <tr>
                        <th>Identificación</th>
                        <th>Nombre</th>
                        <th>Línea</th>
                        <th>Valor</th>
                        <th>Fecha</th>
                      </tr>
                    </thead>

                    <tbody>
                      {creditosOrdenados
                        .sort((a, b) => {
                          const lineaA = String(
                            a.LINEA || ""
                          ).trim();

                          const lineaB = String(
                            b.LINEA || ""
                          ).trim();

                          const comparacionLinea =
                            lineaA.localeCompare(
                              lineaB,
                              "es",
                              {
                                numeric: true,
                                sensitivity: "base"
                              }
                            );

                          if (comparacionLinea !== 0) {
                            return comparacionLinea;
                          }

                          return String(
                            a.CEDULA || ""
                          ).localeCompare(
                            String(b.CEDULA || ""),
                            "es",
                            {
                              numeric: true,
                              sensitivity: "base"
                            }
                          );
                        })
                        .slice(
                          (paginaCred - 1) * 25,
                          paginaCred * 25
                        )
                        .map((credito, index) => (
                          <tr
                            key={`${credito.CEDULA}-${credito.FECHA}-${credito.LINEA}-${index}`}
                          >
                            <td>{credito.CEDULA}</td>

                            <td>{credito.NOMBRE}</td>

                            <td>{credito.LINEA}</td>

                            <td>
                              $
                              {Number(
                                credito.DESEMBOLSO || 0
                              ).toLocaleString("es-CO")}
                            </td>

                            <td>
                              {formatearFechaCredito(
                                credito.FECHA
                              )}
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>

                  <div className="pager">
                    <button
                      type="button"
                      disabled={paginaCred === 1}
                      onClick={() =>
                        setPaginaCred(
                          (paginaActual) =>
                            paginaActual - 1
                        )
                      }
                    >
                      Anterior
                    </button>

                    <span>
                      Página {paginaCred} de{" "}
                      {totalPaginasCred}
                    </span>

                    <button
                      type="button"
                      disabled={
                        paginaCred >= totalPaginasCred
                      }
                      onClick={() =>
                        setPaginaCred(
                          (paginaActual) =>
                            paginaActual + 1
                        )
                      }
                    >
                      Siguiente
                    </button>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      )}

      {!esPublico && !reporte && (

        <div className='saved-reports-box'>

          <h3>Informes guardados</h3>

          <table>

            <thead>
              <tr>
                <th>Cliente</th>
                <th>Periodo</th>
                <th>Código Completo</th>
                <th>Código Resumen</th>
                <th>Fecha de Generación</th>
                <th>Estado</th>
                <th>Acciones</th>
              </tr>
            </thead>

            <tbody>

              {reportesGuardados
                .slice(
                  (paginaGuardados - 1) * 10,
                  paginaGuardados * 10
                )
                .map(r => (

                  <tr key={r._id}>

                    <td>{r.cliente}</td>

                    <td>
                      {r.fechaInicio
                        ? new Date(r.fechaInicio).toISOString().split("T")[0]
                        : "-"}
                      {" → "}
                      {r.fechaFin
                        ? new Date(r.fechaFin).toISOString().split("T")[0]
                        : "-"}
                    </td>

                    <td>{r.codigoAcceso}</td>

                    <td>{r.codigoResumen || "-"}</td>

                    <td>
                      {new Date(r.createdAt).toISOString().slice(0, 10)}
                    </td>

                    <td>
                      {r.publicado ? "Público" : "Privado"}
                    </td>

                    <td className="acciones-icons">

                      <button
                        title="Ver informe completo"
                        onClick={() => verInformeGuardado(r)}
                      >
                        <FiTrendingUp />
                      </button>

                      <button
                        title="Ver resumen"
                        onClick={() => verResumenGuardado(r)}
                      >
                        <FiBarChart />
                      </button>

                      <button
                        title="Compartir"
                        onClick={() => abrirModalCompartir(r)}
                      >
                        <FiShare2 />
                      </button>

                      <button
                        title={r.publicado ? "Cambiar a privado" : "Publicar informe"}
                        onClick={() => toggleEstado(r)}
                      >
                        {r.publicado ? <FiLock /> : <FiGlobe />}
                      </button>

                      <button
                        title="Descargar informe"
                        onClick={() =>
                          window.open(
                            `${API}/api/report/descargar-excel-guardado/${r._id}`,
                            "_blank"
                          )
                        }
                      >
                        <FiDownload />
                      </button>

                      <button
                        title="Eliminar informe"
                        onClick={() => {
                          setReporteAEliminar(r._id);
                          setShowDeleteModal(true);
                        }}
                      >
                        <FiTrash2 />
                      </button>

                    </td>

                  </tr>

                ))}

            </tbody>

          </table>

          <div className='pager'>

            <button
              disabled={paginaGuardados === 1}
              onClick={() => setPaginaGuardados(paginaGuardados - 1)}
            >
              Anterior
            </button>

            <span>
              Página {paginaGuardados} de {totalPaginasGuardados}
            </span>

            <button
              disabled={paginaGuardados === totalPaginasGuardados}
              onClick={() => setPaginaGuardados(paginaGuardados + 1)}
            >
              Siguiente
            </button>

          </div>
        </div>
      )}

      {!esPublico &&
        modalGenerar &&
        createPortal(
          <div
            className="rep-generator-overlay"
            onClick={() => {
              if (!loading) {
                setModalGenerar(false);
              }
            }}
          >
            <div
              className="rep-generator-modal"
              role="dialog"
              aria-modal="true"
              aria-labelledby="rep-generator-title"
              onClick={(e) =>
                e.stopPropagation()
              }
            >
              <div className="rep-generator-header">
                <div>
                  <h3 id="rep-generator-title">
                    Configurar Informe de Gestión
                  </h3>

                  <p>
                    Selecciona las empresas y el periodo
                    del informe.
                  </p>
                </div>

                <button
                  type="button"
                  className="rep-generator-close"
                  onClick={() =>
                    setModalGenerar(false)
                  }
                  disabled={loading}
                  aria-label="Cerrar"
                >
                  <FiX />
                </button>
              </div>

              <div className="rep-generator-body">
                {/* TIPO DE INFORME */}
                <section className="rep-generator-section">
                  <div className="rep-generator-section-title">
                    <span>1</span>

                    <div>
                      <h4>Alcance del informe</h4>
                      <p>
                        Elige una empresa, un grupo o
                        todas las empresas.
                      </p>
                    </div>
                  </div>

                  <div className="rep-scope-options">
                    <button
                      type="button"
                      className={
                        tipoSeleccion === "empresa"
                          ? "active"
                          : ""
                      }
                      onClick={() => {
                        setTipoSeleccion("empresa");
                        setModoGrupo(false);
                        setEmpresasGrupo([]);
                        setNombreGrupo("");
                      }}
                    >
                      Una empresa
                    </button>

                    <button
                      type="button"
                      className={
                        tipoSeleccion === "grupo"
                          ? "active"
                          : ""
                      }
                      onClick={() => {
                        setTipoSeleccion("grupo");
                        setModoGrupo(true);
                      }}
                    >
                      Grupo
                    </button>

                    <button
                      type="button"
                      className={
                        tipoSeleccion === "todas"
                          ? "active"
                          : ""
                      }
                      onClick={() => {
                        setTipoSeleccion("todas");
                        setModoGrupo(true);
                        setNombreGrupo(
                          "Todas las empresas"
                        );
                        setEmpresasGrupo([
                          ...empresas
                        ]);
                        setCliente("");
                        setSugerencias([]);
                      }}
                    >
                      Todas
                    </button>
                  </div>

                  {tipoSeleccion === "empresa" && (
                    <div className="rep-generator-field empresa-search">
                      <label>Empresa</label>

                      <input
                        className="empresa-input"
                        placeholder="Buscar empresa..."
                        value={cliente}
                        onChange={(e) => {
                          const value =
                            e.target.value;

                          setCliente(value);

                          if (value.length >= 2) {
                            const filtro =
                              empresas.filter(
                                (empresa) =>
                                  empresa
                                    .toLowerCase()
                                    .includes(
                                      value.toLowerCase()
                                    )
                              );

                            setSugerencias(
                              filtro.slice(0, 8)
                            );
                          } else {
                            setSugerencias([]);
                          }
                        }}
                      />

                      {sugerencias.length > 0 && (
                        <ul className="autocomplete-list">
                          {sugerencias.map(
                            (empresa) => (
                              <li
                                key={empresa}
                                onClick={() => {
                                  setCliente(empresa);
                                  setSugerencias([]);
                                }}
                              >
                                {empresa}
                              </li>
                            )
                          )}
                        </ul>
                      )}
                    </div>
                  )}

                  {tipoSeleccion === "grupo" && (
                    <div className="rep-group-summary">
                      <div>
                        <strong>
                          {nombreGrupo ||
                            "Grupo sin nombre"}
                        </strong>

                        <span>
                          {empresasGrupo.length} empresa
                          {empresasGrupo.length === 1
                            ? ""
                            : "s"} seleccionada
                          {empresasGrupo.length === 1
                            ? ""
                            : "s"}
                        </span>
                      </div>

                      <button
                        type="button"
                        className="rep-btn-secondary"
                        onClick={() =>
                          setModalGrupo(true)
                        }
                      >
                        {empresasGrupo.length > 0
                          ? "Editar grupo"
                          : "Crear grupo"}
                      </button>
                    </div>
                  )}

                  {tipoSeleccion === "todas" && (
                    <div className="rep-all-companies">
                      <FiUsers />

                      <div>
                        <strong>
                          Todas las empresas
                        </strong>

                        <span>
                          Se incluirán {empresas.length} empresas.
                        </span>
                      </div>
                    </div>
                  )}
                </section>

                {/* PERIODO */}
                <section className="rep-generator-section">
                  <div className="rep-generator-section-title">
                    <span>2</span>

                    <div>
                      <h4>Periodo del informe</h4>
                      <p>
                        Define las fechas que se utilizarán
                        para el informe.
                      </p>
                    </div>
                  </div>

                  <div className="rep-date-grid">
                    <div className="rep-generator-field">
                      <label>Fecha inicial</label>

                      <input
                        type="date"
                        value={fechaInicio}
                        max={fechaFin || undefined}
                        onChange={(e) =>
                          setFechaInicio(
                            e.target.value
                          )
                        }
                      />
                    </div>

                    <div className="rep-generator-field">
                      <label>Fecha final</label>

                      <input
                        type="date"
                        value={fechaFin}
                        min={fechaInicio || undefined}
                        onChange={(e) =>
                          setFechaFin(
                            e.target.value
                          )
                        }
                      />
                    </div>
                  </div>
                </section>

                {/* FUENTES */}
                <section className="rep-generator-section">
                  <div className="rep-generator-section-title">
                    <span>3</span>

                    <div>
                      <h4>Fuentes de información</h4>
                      <p>
                        Empleados y asociados se consultan
                        automáticamente.
                      </p>
                    </div>
                  </div>

                  <div className="rep-source-grid">
                    <div
                      className={`rep-source-card ${empleadosActualizados
                        ? "source-current"
                        : "source-outdated"
                        }`}
                    >
                      <div
                        className={`rep-source-status ${empleadosActualizados
                          ? "success"
                          : "outdated"
                          }`}
                      />

                      <div>
                        <strong>
                          Empleados activos
                        </strong>

                        <span>
                          {Number(
                            estadoArchivos.empleados
                              ?.totalRegistros || 0
                          ).toLocaleString("es-CO")} registros
                        </span>

                        <small>
                          Actualización:{" "}
                          {formatearFechaHora(
                            estadoArchivos.empleados
                              ?.ultimaCarga
                          )}
                        </small>

                        <small
                          className={
                            empleadosActualizados
                              ? "source-status-text current"
                              : "source-status-text outdated"
                          }
                        >
                          {fechaFin
                            ? empleadosActualizados
                              ? "Actualizado para el periodo seleccionado"
                              : "Fuente anterior a la fecha final del informe"
                            : "Selecciona el periodo para validar"}
                        </small>
                      </div>
                    </div>

                    <div
                      className={`rep-source-card ${asociadosActualizados
                        ? "source-current"
                        : "source-outdated"
                        }`}
                    >
                      <div
                        className={`rep-source-status ${asociadosActualizados
                          ? "success"
                          : "outdated"
                          }`}
                      />

                      <div>
                        <strong>
                          Reporte 102
                        </strong>

                        <span>
                          {Number(
                            estadoArchivos.asociados
                              ?.totalRegistros || 0
                          ).toLocaleString("es-CO")} registros
                        </span>

                        <small>
                          Actualización:{" "}
                          {formatearFechaHora(
                            estadoArchivos.asociados
                              ?.ultimaCarga
                          )}
                        </small>

                        <small
                          className={
                            asociadosActualizados
                              ? "source-status-text current"
                              : "source-status-text outdated"
                          }
                        >
                          {fechaFin
                            ? asociadosActualizados
                              ? "Actualizado para el periodo seleccionado"
                              : "Fuente anterior a la fecha final del informe"
                            : "Selecciona el periodo para validar"}
                        </small>
                      </div>
                    </div>
                  </div>

                  <div
                    className={`rep-credit-source ${creditosActualizados
                      ? "source-current"
                      : "source-outdated"
                      }`}
                  >
                    <div className="rep-credit-source-header">
                      <div>
                        <strong>
                          Créditos
                        </strong>

                        <span>
                          {estadoArchivos.creditos
                            ?.disponible
                            ? `${Number(
                              estadoArchivos.creditos
                                ?.totalRegistros || 0
                            ).toLocaleString(
                              "es-CO"
                            )} registros disponibles`
                            : "No hay créditos disponibles"}
                        </span>

                        <small>
                          Última carga:{" "}
                          {formatearFechaHora(
                            estadoArchivos.creditos
                              ?.ultimaCarga
                          )}
                        </small>

                        <small
                          className={
                            creditosActualizados
                              ? "source-status-text current"
                              : "source-status-text outdated"
                          }
                        >
                          {!fechaFin
                            ? "Selecciona el periodo para validar"
                            : creditosActualizados
                              ? "Actualizado para el periodo seleccionado"
                              : "Puedes cargar un archivo más reciente"}
                        </small>
                      </div>
                    </div>

                    <label className="rep-credit-upload">
                      <FiUploadCloud />

                      <div>
                        <strong>
                          {archivoCreditos
                            ? archivoCreditos.name
                            : "Seleccionar archivo de créditos"}
                        </strong>

                        <span>
                          Formatos admitidos: XLSX y XLS
                        </span>
                      </div>

                      <input
                        ref={refCreditos}
                        type="file"
                        accept=".xlsx,.xls"
                        onChange={(e) =>
                          setArchivoCreditos(
                            e.target.files?.[0] ||
                            null
                          )
                        }
                      />
                    </label>

                    {archivoCreditos && (
                      <button
                        type="button"
                        className="rep-upload-now"
                        onClick={
                          subirArchivoCreditos
                        }
                        disabled={subiendoCreditos}
                      >
                        <FiUploadCloud />

                        {subiendoCreditos
                          ? "Cargando créditos..."
                          : "Actualizar créditos ahora"}
                      </button>
                    )}
                  </div>
                </section>
              </div>

              <div className="rep-generator-footer">
                <button
                  type="button"
                  className="rep-btn-ghost"
                  onClick={
                    restablecerConfiguracion
                  }
                  disabled={
                    loading ||
                    subiendoCreditos
                  }
                >
                  <FiRefreshCw />
                  Restablecer
                </button>

                <div>
                  <button
                    type="button"
                    className="rep-btn-primary"
                    onClick={generarReporte}
                    disabled={
                      loading ||
                      subiendoCreditos
                    }
                  >
                    <FiBarChart2 />

                    {loading
                      ? "Generando informe..."
                      : "Generar informe"}
                  </button>
                </div>
              </div>
            </div>
          </div>,
          document.body
        )}

      {showDeleteModal && (
        <div
          className="modal-backdrop"
          onClick={() => {
            setShowDeleteModal(false);
            setReporteAEliminar(null);
          }}
        >
          <div
            className="modal-delete"
            onClick={(e) => e.stopPropagation()}
          >
            <h3>Confirmar Eliminación</h3>

            <p>
              ¿Deseas eliminar este informe?
            </p>

            {/* 👇 CLASE CORRECTA */}
            <div className="modal-delete-actions">

              <button
                className="rep-btn-secondary"
                onClick={() => {
                  setShowDeleteModal(false);
                  setReporteAEliminar(null);
                }}
              >
                Cancelar
              </button>

              <button
                className="rep-btn-primary"
                onClick={async () => {
                  await eliminarInforme(reporteAEliminar);

                  setShowDeleteModal(false);
                  setReporteAEliminar(null);
                }}
              >
                Eliminar
              </button>

            </div>
          </div>
        </div>
      )}

      {modalCompartir && (
        <div
          className="rep-generator-overlay"
          onClick={() =>
            setModalCompartir(false)
          }
        >
          <div
            className="modal-share"
            onClick={(e) =>
              e.stopPropagation()
            }
          >
            <h3>
              Compartir Informe
            </h3>

            <p>
              Selecciona la versión que deseas enviar.
            </p>

            <label>
              <input
                type="radio"
                name="tipoCompartir"
                checked={
                  tipoCompartir ===
                  "completo"
                }
                onChange={() =>
                  setTipoCompartir(
                    "completo"
                  )
                }
              />

              Informe completo
            </label>

            <label>
              <input
                type="radio"
                name="tipoCompartir"
                checked={
                  tipoCompartir ===
                  "resumen"
                }
                onChange={() =>
                  setTipoCompartir(
                    "resumen"
                  )
                }
              />

              Resumen ejecutivo
            </label>

            <div className="modal-delete-actions">
              <button
                className="rep-btn-secondary"
                onClick={() =>
                  setModalCompartir(false)
                }
              >
                Cancelar
              </button>

              <button
                className="rep-btn-primary"
                onClick={compartirInforme}
              >
                Compartir
              </button>
            </div>
          </div>
        </div>
      )}

    </div>

    </>

  );
}

export default Reportes;